"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    setStartDirection
  } = (0, _hooks.useStylesUtils)();
  const ccLoginBtnStyle = (0, _react.useMemo)(() => {
    const ccLoginBtnImage = (0, _css.css)({
      height: 'auto',
      top: '50%',
      transform: 'translate(0, -50%)',
      position: 'absolute'
    });
    const ccLoginBtnText = (0, _css.css)({
      fontFamily: fontFamily,
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      fontSize: pxToRem(20),
      lineHeight: pxToRem(25),
      ...setStartDirection(85)
    });
    const ccLoginBtn = (0, _css.css)({
      background: '#FAFAFA',
      fontWeight: '600',
      position: 'relative',
      border: `${pxToRem(2)} solid currentColor`,
      borderRadius: pxToRem(8),
      width: '100%',
      display: 'block',
      cursor: 'pointer',
      textAlign: 'start',
      '&:nth-child(1)': {
        color: 'black',
        height: pxToRem(128),
        marginBottom: pxToRem(5),
        ['.' + ccLoginBtnImage]: {
          width: pxToRem(40),
          ...setStartDirection(30)
        }
      },
      '&:nth-child(2)': {
        color: themeColors?.primary.main,
        height: pxToRem(65),
        ['.' + ccLoginBtnImage]: {
          width: pxToRem(40),
          ...setStartDirection(30)
        }
      }
    });
    return {
      ccLoginBtn,
      ccLoginBtnImage,
      ccLoginBtnText
    };
  }, [fontFamily, themeColors, pxToRem, setStartDirection]);
  return {
    'cc-Login__login-btn': ccLoginBtnStyle.ccLoginBtn,
    'cc-Login__login-btn__image': ccLoginBtnStyle.ccLoginBtnImage,
    'cc-Login__login-btn__text': ccLoginBtnStyle.ccLoginBtnText
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;